module.exports = __webpack_public_path__ + "img/zgzpt3.6bfe52b2.png";